export const pricingData = [
    {
        title: "3 Bottles",
        subtitle: "90 Day Supply",
        pricePerBottle: 59,
        totalBottles: 3,
        originalPrice: 597,
        discountedPrice: 177,
        features: [
            "FAST & FREE SHIPPING",
            "180 DAY GUARANTEE"
        ],
        product: "https://cdn.blackincae.com/product-images/LR_Bottle_4_60ML.png",
    },
    {
        title: "Buy 6",
        subheading: '+ Get 6 FREE!',

        subtitle: "360 Day Supply",
        bottleCount: "(12 Bottles)",
        pricePerBottle: 59,
        totalBottles: 12,
        originalPrice: 2388,
        discountedPrice: 354,
        features: [
            "BIGGEST DISCOUNT",
            "FAST & FREE SHIPPING",
            "3 BONUSES",
            "180 DAY GUARANTEE"
        ],
        product: "https://cdn.blackincae.com/product-images/LR_Bottle_Bottle_6_V2_60ML.png",
        bestValue: true,
    },
    {
        title: "Buy 5 ",
        subheading: '+ Get 1 FREE!',
        subtitle: "180 Day Supply",
        bottleCount: "(6 Bottles)",
        pricePerBottle: 59,
        totalBottles: 6,
        originalPrice: 1194,
        discountedPrice: 295,
        features: [
            "FAST & FREE SHIPPING",
            "3 BONUSES",
            "180 DAY GUARANTEE"
        ],
        product: "https://cdn.blackincae.com/product-images/LR_Bottle_4_60ML.png",
    }
]